const HALF_PI = Math.PI / 2;
export const PRINT_ORIENTATIONS = [
  { id: 0, label: "as loaded", rot: [0, 0, 0], permute: (b) => ({ x: b.x, y: b.y, z: b.z }) },
  { id: 1, label: "rot X 90°", rot: [HALF_PI, 0, 0], permute: (b) => ({ x: b.x, y: b.z, z: b.y }) },
  { id: 2, label: "rot Y 90°", rot: [0, HALF_PI, 0], permute: (b) => ({ x: b.y, y: b.x, z: b.z }) },
  { id: 3, label: "rot Z 90°", rot: [0, 0, HALF_PI], permute: (b) => ({ x: b.z, y: b.y, z: b.x }) },
];
export const DEFAULT_PRINT_BED = Object.freeze({ x: 218, y: 122, z: 200 });

export function selectPrintOrientation(bbox, scale, bed) {
  if (!bbox) return PRINT_ORIENTATIONS[0];
  return PRINT_ORIENTATIONS.find((orientation) => {
    const p = orientation.permute(bbox);
    return p.x * scale <= bed.x && p.y * scale <= bed.y && p.z * scale <= bed.z;
  }) || PRINT_ORIENTATIONS[0];
}